<template>
  <div class="page-container">
    <div class="well">
      <div class="level">
        <div class="level-left">
          <h1 v-if="isCreated">New Purchase Order - #{{ poData.poNumber }} - {{ poData.purchasingAgent }}</h1>
          <h1 v-else>New Purchase Order - {{ userInfo.employeeName }}</h1>
        </div>
        <div class="level-right">
          <button v-if="isCreated" class="button is-medium is-info" @click="printPage">Print</button>
        </div>
      </div>
      <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
      <po-form 
        :formData="poData"
        ref="poForm"
        :editing="1"
        :receiving="0"
        :salesContact="salesContact"
        :vendorOptions="vendorOptions">
      </po-form>
      <div class="level">
        <h1>Documents</h1>
      </div>
      <po-documents :documents="documents"></po-documents>
      <b-message v-if="!isCreated" type="is-primary" has-icon>
        Documents can be uploaded once the purchase order has been created.
      </b-message>
      <button class="button is-info is-fullwidth" :disabled="!isCreated" @click="openUploader">
        Upload Documents
      </button>
      <b-modal :active.sync="isComponentModalActive" has-modal-card>
          <document-uploader 
            :dropFiles="dropFiles" 
            :recordID="poData.recordID" 
            :docPortal="documents"
            :purchaseOrderID="poData.__kptID"
            @load-data="delayedRefresh"
            ref="cardWindow">
          </document-uploader>
      </b-modal>
      <div class="level">
        <b-field>
          <h1>Items</h1>
        </b-field>
      </div>
      <po-lines 
        :data=this.lineData 
        :editing="1" 
        :receiving="0" 
        :newPO="1"
        ref="poItems"
        @clicked-add-line-item="addLineItem" 
        @clicked-remove-line-item="removeLineItem">
      </po-lines>
      <div class="button-bar" style="margin: 0 0 0 10">
        <button class="button no-print is-medium is-primary is-pulled-left" @click="cancel"  style="margin-bottom: 10px">Cancel</button>
        <button class="button no-print is-medium is-success is-primary is-pulled-right" v-if="!isCreated" @click="createRecord">Create</button>
        <button class="button no-print is-medium is-success is-primary is-pulled-right" v-else @click="updateRecord">Update</button>
      </div>
    </div>
  </div>
</template>



<script>
  import { mapState } from 'vuex';
  import { mapMutations } from 'vuex';
  import store from '../../store/store.js';
  import PurchaseOrderForm from './PurchaseOrderForm';
  import PurchaseOrderLines from './PurchaseOrderLines';
  import PurchaseOrderDocuments from './PurchaseOrderDocuments';
  import DocumentUploaderCard from './DocumentUploaderCard';

  // const LINE_ITEM_ID = 'purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::__kptID';
  // const LINE_ITEM_IS_RECEIVED = 'purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::isReceived';
  const DEPARTMENT = 'purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::department';
  const TRACKING_NUMBER = 'menu__FINANCE_TRACKING_NUMBER__isActive__srt::name';

  export default {
    
    name: 'PurchaseOrderNewPage',
    components: {
      'po-form': PurchaseOrderForm,
      'po-lines': PurchaseOrderLines,
      'po-documents': PurchaseOrderDocuments,
      'document-uploader': DocumentUploaderCard
    },
    props:['id'],
    data: function() {
      return {
        poData: {},
        lineData: [],
        documents: [],
        removedLineData: [],
        isLoading: false,
        isFullPage: true,
        response: null,
        isCreated: false,
        postRecordId: null,
        dropFiles: [],
        isComponentModalActive: false,
        postCount: 0,
        vendorOptions: [],
        salesContact: {
        name: null,
        cell: null,
        phone: null,
        fax: null,
        email: null,
      }
      };
    },
    computed:{
      ...mapState([
        'userInfo',
        'departmentValueList',
        'vendorValueList',
        'purchasingAgentValueList',
        'lineItemDescriptionValueList',
        'trackingNumberValueList',
        'currentPage',
        'salesContactLookup'
      ]),
      searchQuery: function(){
        var searchQuery = {
            "query": [{
                "recordID": this.postRecordId
            }]
        };
        return searchQuery;
      },
      loadDataQuery: function(){
        var searchQuery = {
            "query": [{
                "__kptID": this.poData.__kptID
            }]
        };
        return searchQuery;
      },
      
      // Returns true if ANY items have "Planer Mill" chosen for department
      includesPlanerDepartment: function(){
        return this.lineData.some(function(lineItem){
          return lineItem[DEPARTMENT] === 'Planer Mill';
        });
      }
    },
    
    created: function(){
      this.loadValueLists();
      this.poData.purchasingAgent = this.userInfo.employeeName;
      if(this.isCreated == true){
        this.loadPurchaseOrderNumber();
      }
      store.commit('updateCurrentPage', 'new');
    },
    
    methods: {
      ...mapMutations([
        'updateSalesContactLookup',
        'updateDepartmentValueList',
        'updateVendorValueList',
        'updatePurchasingAgentValueList',
        'updateLineItemDescriptionValueList',
        'updateTrackingNumberValueList',
        'updateTrackingNumberOptions',
        'updateCurrentPage'
      ]),
      // Creates a new record and saves the data back to FM
      createRecord: function(){
        var validForm = this.$refs.poForm.validate();
        var validVendor = this.$refs.poForm.validateVendor();
        var validLines = true;
        if(this.$refs.poItems.itemsInOrder){
          validLines = this.$refs.poItems.validate();
        }
        if(validForm == false || validLines.valid == false ){
          return;
        }
        if(validLines.trackingNumberValid == false){
          return
        }
        if(validVendor == false){
          this.$toast.open({
                    duration: 5000,
                    message: 'Please fill in a valid vendor.',
                    position: 'is-bottom',
                    type: 'is-primary'
          });
          return;
        }
      
        var compiledData = {
          poData: this.poData,
          lineData: this.lineData,
          // salesContact: this.salesContactLookup[this.poData.vendorName],
          // salesContactFirst: this.salesContactLookup[this.poData.vendorName].split(" ")[0],
          // salesContactLast: this.salesContactLookup[this.poData.vendorName].split(" ")[1],
          // removedLineData: this.removedLineData,
          isReceived: "",
          includesPlanerDepartment: this.includesPlanerDepartment,
        };
        
        // Add in sales contact if it's not empty
        if(this.salesContact.name){
          compiledData.salesContactFirst = this.salesContact.name.split(" ")[0];
          compiledData.salesContactLast = this.salesContact.name.split(" ")[1];
        }
        compiledData.salesContactPhone = this.salesContact.phone;
        compiledData.salesContactCell = this.salesContact.cell;
        compiledData.salesContactFax = this.salesContact.fax
        compiledData.salesContactEmail = this.salesContact.email;
        
        
        var self = this;
        self.isLoading = true;
        var url = 'api/v2/runScript.php?layout=POST&script=POST-UpdateOrCreatePurchaseOrder';
        this.$http.post(url, compiledData)
        .then( response => {
          if(response.data.messages[0].code === "401"){
            this.$toast.open(response.data.messages[0].message);
            self.isLoading = false;
            return;
          }
          if(response.data.messages[0].code  != 0){
            this.$toast.open(response.data.messages[0].message);
            self.isLoading = false;
            return;
          }
          var result = response.data.response.scriptResult.split(',');
          self.poData.poNumber = result[0];
          self.poData.__kptID = result[1];
          self.loadData();
          self.isCreated = true;
          this.$toast.open({
                    duration: 5000,
                    message: 'Created successfully',
                    position: 'is-bottom',
                    type: 'is-success'
          });
        })
        .catch( error => {
          if (error.response) {
            this.$toast.open(error.response.status);
          } 
          else {
            this.$toast.open("Unknown Error");
          }
        });
      },
      
      // Loads in value lists for Department, Vendor, and line item description
      loadValueLists: function(){
        // if((this.departmentValueList.length > 0) && (this.vendorValueList > 0) && (this.purchasingAgentValueList > 0)){
        // if((this.departmentValueList.length > 0) && (this.vendorValueList > 0)){
        //   return;
        // }
        self = this;
        this.$http.get('api/v2/getValueList.php')
        .then( response => {
          if(response.data.messages[0].code === "401"){
            this.$toast.open(response.data.messages[0].message);
            return;
          }
          if(response.data.messages[0].code != 0){
            this.$toast.open(response.data.messages[0].message);
            return;
          }
          var departmentData = [];
          var vendorData = [];
          var lineItemDescriptionData = [];
          var trackingNumberData = [];
          var trackingNumberOptions = [];
          var salesContactLookup = {}
             
          var departmentPortal = response.data.response.data[0].portalData['PORTAL-Department-Active'];
          var vendorPortal = response.data.response.data[0].portalData['PORTAL-Vendor-Active'];
          var lineItemDescriptionPortal = response.data.response.data[0].portalData['PORTAL-LineItem'];
          var trackingNumberPortal = response.data.response.data[0].portalData['PORTAL-Tracking-Active'];

          // Push data to arrays
          departmentPortal.forEach(function(row){ 
            departmentData.push(row);
          });
          trackingNumberPortal.forEach(function(row){ 
            trackingNumberData.push(row);
          });
          trackingNumberData.forEach(function(trackingNumber){
            trackingNumberOptions.push(trackingNumber['menu__FINANCE_TRACKING_NUMBER__isActive__srt::name']);
          });
          vendorPortal.forEach(function(row){ 
            self.vendorOptions.push(row['menu__VENDOR__isActive__srt::vendorName']);
            vendorData.push(row);
            // Build a dictionary to find the sales contact
            // if(row['menu__VENDOR__cart__srt::zctContactFullName'] != "" && row['menu__VENDOR__cart__srt::zctContactFullName'] != null){
              salesContactLookup[row['menu__VENDOR__isActive__srt::vendorName'].toLowerCase()] = {
                'name': row['menu__VENDOR__isActive__srt::zctSalesContactFullName'],
                'cell': row['menu__VENDOR__isActive__srt::salesContactCellPhone'],
                'email': row['menu__VENDOR__isActive__srt::salesContactEmail'],
                'fax': row['menu__VENDOR__isActive__srt::salesContactFax'],
                'phone': row['menu__VENDOR__isActive__srt::salesContactPhone']
            };
            // }
          });
          lineItemDescriptionPortal.forEach(function(row){
            lineItemDescriptionData.push(row['menu__PURCHASE_ORDER_LINE_ITEM__cart_srt::description']);
          });
          lineItemDescriptionData = self.uniqueDescriptions(lineItemDescriptionData);
          // Save to store
          store.commit('updateSalesContactLookup', salesContactLookup);
          store.commit('updateDepartmentValueList', departmentData);
          store.commit('updateVendorValueList', vendorData);
          store.commit('updateLineItemDescriptionValueList', lineItemDescriptionData);
          store.commit('updateTrackingNumberValueList', trackingNumberData);
          store.commit('updateTrackingNumberOptions', trackingNumberOptions);
        })
        .catch( error => {
          if (error.response) {
            this.$toast.open(error.response.status);
          } 
          else {
            this.$toast.open("Unknown Error");
          }
        });
      },
      
      /*
      Compares the number of emits from child to number of documents to upload
      reloads data if all the posts have completed and closes the card window
      */
      delayedRefresh: function(){
        this.postCount++;
        if(this.postCount == this.dropFiles.length){
          this.loadData();
          this.postCount = 0;
          this.$refs.cardWindow.closeWindow();
          this.$refs.cardWindow.isLoading = false;
        }
      },
      // Returns a unique set of an array
      uniqueDescriptions: function(array){
        var temp = {};
        for(var i =0; i < array.length; i++){
          temp[array[i]] = true;
        }
        return Object.keys(temp);
      },
      // Loads purchase order from FM
      loadData: function(){
        var self = this;
        var poForm = this.$refs.poForm;
        self.isLoading = true;
        this.loadValueLists();
        // Clear out portal data, if reloading after uploading a document upload
        self.lineData = [];
        self.documents = [];
      
        this.$http.post('api/v2/find.php?layout=purchaseOrder-dataEntry', this.loadDataQuery)
        .then( response => {
          if(response.data.messages[0].code === "401"){
            this.$toast.open(response.data.messages[0].message);
            self.isLoading = false;
            return;
          }
          if(response.data.messages[0].code != 0){
            this.$toast.open(response.data.messages[0].message);
            self.isLoading = false;
            return;
          }
          console.log(response);
          // response.data.response.data.forEach(function(record){
            var record = response.data.response.data[0];
            self.poData = record.fieldData;
            
            var parts = self.poData.orderDate.split("/");
            var dt = new Date(
                parseInt(parts[2]),
                parseInt(parts[0])-1,
                parseInt(parts[1])
              );
            poForm.setDate(dt);
              
            var lineItemsPortal = record.portalData['PORTAL:PurchaseOrderItems']; 
            lineItemsPortal.forEach(function(row){ 
              self.lineData.push(row);
            });
            
            var documentsPortal = record.portalData['PORTAL:Documents'];
            documentsPortal.forEach(function(row){
              row.showDoc = false;
              self.documents.push(row);
            });
            
          // }); 
          self.isLoading = false;
        })
        .catch( error => {
          if (error.response) {
            this.$toast.open(error.response.status);
          } 
          else {
            this.$toast.open("Unknown Error");
          }
        });
      },
      // Writes purchase order changes back to FM
      updateRecord: function(){
        var validForm = this.$refs.poForm.validate();
        var validLines = true;
        var validVendor = this.$refs.poForm.validateVendor();
        if(this.$refs.poItems.itemsInOrder){
          validLines = this.$refs.poItems.validate();
        }
        if(validForm == false || validLines.valid == false ){
          return;
        }
        if(validLines.trackingNumberValid == false){
          return
        }
        if(validVendor == false){
          this.$toast.open({
                    duration: 5000,
                    message: 'Please fill in a valid vendor.',
                    position: 'is-bottom',
                    type: 'is-primary'
          });
          return;
        }
        
        var compiledData = {
          poData: this.poData,
          // salesContactFirst: this.salesContactLookup[this.poData.vendorName].split(" ")[0],
          // salesContactLast: this.salesContactLookup[this.poData.vendorName].split(" ")[1],
          
          lineData: this.lineData,
          includesPlanerDepartment: this.includesPlanerDepartment
        };
        // Add in sales contact if it's not empty
        if(this.salesContact.name){
          compiledData.salesContactFirst = this.salesContact.name.split(" ")[0];
          compiledData.salesContactLast = this.salesContact.name.split(" ")[1];
        }
        compiledData.salesContactPhone = this.salesContact.phone;
        compiledData.salesContactCell = this.salesContact.cell;
        compiledData.salesContactFax = this.salesContact.fax
        compiledData.salesContactEmail = this.salesContact.email;
        var self = this;
        self.isLoading = true;
        var url = 'api/v2/runScript.php?layout=POST&script=POST-UpdateOrCreatePurchaseOrder';
        this.$http.post(url, compiledData)
        .then( response => {
          if(response.data.messages[0].code === "401"){
            self.$toast.open(response.data.messages[0].message);
            return;
          }
          if(response.data.messages[0].code  != 0){
            self.$toast.open(response.data.messages[0].message);
            return;
          }
          // Update PO number on web
          if(self.includesPlanerDepartment && self.poData.poNumber[0] != 'P' ){
            self.poData.poNumber = "P" + self.poData.poNumber;
          }
          else if(!self.includesPlanerDepartment && self.poData.poNumber[0] == 'P'){
            self.poData.poNumber = self.poData.poNumber.substring(1);
          }
          self.loadData();
          this.$toast.open({
                    duration: 5000,
                    message: 'Updated successfully',
                    position: 'is-bottom',
                    type: 'is-success'
          });
            // this.$router.push({name: 'DashboardPage'});
        })
        .catch( error => {
          if (error.response) {
            this.$toast.open(error.response.status);
          } 
          else {
            this.$toast.open("Unknown Error");
          }
        });
      },
      // Cancels the creation of a new purchase order and returns to the dashboard
      cancel: function(){
        this.$router.push({name: 'DashboardPage'});
      },
      
      // Picks up emit from child and adds a new blank line item 
      addLineItem: function(obj){
        this.lineData.push(obj);
      },
      
      // Picks up emit from child and removes the chosen line item
      removeLineItem: function(lineItem){
        this.lineData = this.lineData.filter(function(i){
          if(i.recordId != lineItem.recordId) return true;
          else return false;
        });
      },
      
      // Opens uploader card window
      openUploader: function(){
        this.dropFiles = [];
        this.isComponentModalActive = true;
      },
      // Brings up the print dialogue window, can save to pdf from there
      printPage: function(){
        window.print();
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .level h1{
    font-family: 'Poppins', sans-serif;
    font-size: 2rem;
    font-weight: 600;
    }
    
  .well{
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 15px;
  }
  
  .is-danger {
    background-color: #d00a0b;
    color: white;
  }
  
  .button-bar{
    margin-top: 10px;
    margin-bottom: 15px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/PurchaseOrder/PurchaseOrderNewPage.vue